export default "__VITE_ASSET__1l44R9W___"